import en from './en/translation';
import it from './it/translation';
import de from './de/translation';
import fr from './fr/translation';
import zh from './zh/translation';
import he from './he/translation';
import ar from './ar/translation';
import ru from './ru/translation';
import es from './es/translation';

export default {
  en: { translation: en },
  it: { translation: it },
  de: { translation: de },
  fr: { translation: fr },
  zh: { translation: zh },
  he: { translation: he },
  ar: { translation: ar },
  ru: { translation: ru },
  es: { translation: es },
};
